import dashboardIcon from '../../../assets/img/01-Icon-dashboard-orange.png';
import notificationIcon from '../../../assets/img/02-icon-notifications.png';
import scheduleEventIcon from '../../../assets/img/03-icon-schedule-event.png';
import employeeIcon from '../../../assets/img/employees-tested.png';
import employeeIcon_Active from '../../../assets/img/employees-tested-orange.png';
import locationIcon from '../../../assets/img/02-icon-notifications.png';
import collectionSiteIcon from '../../../assets/img/06-Icon-collection-sites.png';
// import drugAlcoholTestingIcon from '../../../assets/img/04-Icon-drug-alcohol-testing.png';
import trainingIcon from '../../../assets/img/09-icon-training.png';
import covidTestingIcon from '../../../assets/img/11-icon-COVID.png';
import covidVaccinationIcon_Active from '../../../assets/img/covidVaccOrange.png';
import covidTestingIcon_Active from '../../../assets/img/11-icon-COVID-orange.png';
import policyIcon from '../../../assets/img/15-icon-policies.png';
import randomTestingPoolIcon from '../../../assets/img/05-Icon-random-testing-pools.png';
import backgroundScreenIcon from '../../../assets/img/07-icon-background-screening.png';
import medicalSurvellianceIcon from '../../../assets/img/08-icon-medical-surveillance.png';
import eapProgramIcon from '../../../assets/img/10-icon-EAP-program.png';
import orderSupplyIcon from '../../../assets/img/12-icon-order-supplies.png';
import invoicesIcon from '../../../assets/img/13-icon-invoices.png';
import companyInformationIcon from '../../../assets/img/14-icon-company-info.png';
import covidVaccinationIcon from '../../../assets/img/Covid-vaccination.png';

const images = {
  dashboardIcon,
  employeeIcon_Active,
  notificationIcon,
  scheduleEventIcon,
  employeeIcon,
  locationIcon,
  covidVaccinationIcon_Active,
  covidTestingIcon_Active,
  collectionSiteIcon,
  // drugAlcoholTestingIcon,
  trainingIcon,
  covidTestingIcon,
  covidVaccinationIcon,
  policyIcon,
  randomTestingPoolIcon,
  backgroundScreenIcon,
  medicalSurvellianceIcon,
  eapProgramIcon,
  orderSupplyIcon,
  invoicesIcon,
  companyInformationIcon,
};

function getImageByKey(key) {
  return images[key]
}

export default getImageByKey